import type { ReactNode } from 'react'

import { Table } from '@components/molecules/Table'

const rows: [string, string, string, string][] = [
  [
    'Main sidebar (Sidebar)',
    'The most important places in the app.',
    'Down the left of every page.',
    'Supporters, Events, Settings.',
  ],
  [
    'Page header nav (PageHeaderNav)',
    'Sibling pages under one sidebar item.',
    'Under the page header.',
    'Configurations, Embeds and Filters under Settings.',
  ],
  [
    'Section nav (SectionNav)',
    'A third level, when one page header tab holds several pages of its own.',
    'Down the left of the page body.',
    'General, NationBuilder and Mailers under Configurations.',
  ],
]

function Text({ children }: { children: ReactNode }) {
  return <p className="tw:max-w-prose tw:text-sm tw:text-gray-cool-700">{children}</p>
}

export function ChoosingNavLevel() {
  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <Text>
        Links go at the highest level their importance earns. The most important go in the main sidebar. The next most
        important go in the page header nav. Use the section nav only when a page header tab needs another level below
        it.
      </Text>
      <div className="tw:overflow-hidden tw:rounded-xl tw:border tw:border-gray-cool-200">
        <Table.Root>
          <Table.Header className="tw:bg-gray-cool-50">
            <Table.Row>
              <Table.Head>Level</Table.Head>
              <Table.Head>Holds</Table.Head>
              <Table.Head>Where it sits</Table.Head>
              <Table.Head>In this app</Table.Head>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {rows.map(([label, ...cells]) => (
              <Table.Row key={label}>
                <Table.Cell className="tw:whitespace-nowrap tw:align-top tw:text-sm tw:font-medium tw:text-gray-cool-900">
                  {label}
                </Table.Cell>
                {cells.map((cell) => (
                  <Table.Cell key={cell} className="tw:align-top tw:text-sm tw:text-gray-cool-700">
                    {cell}
                  </Table.Cell>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </div>
      <Text>Never skip a level. A section nav always sits under a current page header tab.</Text>
    </div>
  )
}
